export enum FLOWS {
  TILE_DESIGNER = 'TILE_DESIGNER',
  PHOTO_BOOKS = 'PHOTO_BOOKS',
  CART = 'CART',
}

export const FLOW_TO_KEY = {
  [FLOWS.TILE_DESIGNER]: 'designerUserCartId',
  [FLOWS.PHOTO_BOOKS]: 'photoBooksUserCartId',
  [FLOWS.CART]: 'userCartId',
}
